import React from 'react';
import { List, ListItemText } from '@mui/material';
import { RoleListItem } from '../../styles/StyledComponents';
import { ROLES } from '../../config/constants';

const RoleSelector = ({ selectedRole, onRoleSelect }) => {
  return (
    <List>
      {Object.values(ROLES).map((role) => (
        <RoleListItem
          key={role.id}
          button
          selected={selectedRole === role.id}
          onClick={() => onRoleSelect(role.id)}
        >
          <ListItemText
            primary={role.name}
            secondary={role.description}
            primaryTypographyProps={{
              style: { color: '#F9FAFB', fontWeight: selectedRole === role.id ? 600 : 400 }
            }}
            secondaryTypographyProps={{
              style: { color: '#9CA3AF' }
            }}
          />
        </RoleListItem>
      ))}
    </List>
  );
};

export default RoleSelector;
